import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { API, APIRoutes, BANNER_TARGETS } from '@utils/api';
import MainBanner from '@components/PageBanner';

import Offers from '@components/Offers/OffersList';
import HorizontalRule from '@pages/employers/style';

interface OfferListProps {
  offers: OfferBox[];
  banners: BannerItem[];
}

function OffersList({ offers, banners }: OfferListProps) {
  const { t } = useTranslation('offers');

  return (
    <>
      <Head>
        <title>{t('page-title')}</title>
      </Head>

      <MainBanner bannerItems={banners} />
      <HorizontalRule />
      <Offers offers={offers} />
    </>
  );
}

export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
  try {
    const {
      data: { banners },
    } = await API.get(APIRoutes.banners(BANNER_TARGETS.HOMEPAGE));

    const { data: offers } = await API.get(
      APIRoutes.offers({
        page: query.page || 1,
        industry: query.industry,
        workModel: query.workModel,
        practiceType: query.practiceType,
        companyPosition: query.companyPosition,
      })
    );

    return {
      props: {
        ...(await serverSideTranslations(locale, ['homepage', 'navbar', 'footer', 'offers', 'bottomBanner', 'common'])),
        banners,
        offers,
      },
    };
  } catch (error) {
    return { props: {} };
  }
}

export default OffersList;
